import CustomCardHeader from "../../../components/card/CustomCardHeader";
import CustomButton, { DangerButton, SemiTransparentButton } from "../../../components/CustomButton";
import CardBody from "../../../components/card/CardBody";
import CustomCard from "../../../components/card/CustomCard";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAreasByCity,
  fetchCitiesByProvince,
  setCurrentArea, setCurrentCity, setCurrentProvince
} from "../../../redux/slices/locationSlice";
import { LocationItem, LocationItemLoader } from "./LocationItem";
import { useNavigate } from "react-router-dom";
import AreaDetail from "./locationDetails/AreaDetail";
import ProvinceDetail from "./locationDetails/ProvinceDetail";
import CityDetail from "./locationDetails/CityDetail";

export const LocationService = () => {
  const navigate = useNavigate()
  return (
    <CustomCard>
      <CustomCardHeader color="blue" contentPosition="none">
        <div className="flex items-center justify-between w-full">
          <h2 className="text-2xl text-white">Manage Locations</h2>
          <SemiTransparentButton onClick={() => {
            navigate(`/location-bulk`)
          }}>
            Bulk Update
          </SemiTransparentButton>
        </div>
      </CustomCardHeader>

      <CardBody className="h-screen">
        <div className="flex h-full space-x-4">
          {/*province, city, area section*/}
          <ProvinceCityAndAreaSection />
          {/*detail section*/}
          <LocationDetailSection />
        </div>
      </CardBody>
    </CustomCard>
  )
}

const ProvinceCityAndAreaSection = () => {
  const { province, city, area, currentProvince, currentCity, currentArea } = useSelector((state => state.location))

  const dispatch = useDispatch()

  // for filtering cities and areas (local search)
  const [filteredCities, setFilteredCities] = useState()
  const [filteredAreas, setFilteredAreas] = useState()
  const [citySearch, setCitySearch] = useState("")
  const [areaSearch, setAreaSearch] = useState("")

  const filterCities = (query) => {
    setCitySearch(query)
    if (query.trim() === "") {
      setFilteredCities()
    } else {
      const cities = city.data.filter((c) => c.name.toUpperCase().includes(query.toUpperCase()))
      setFilteredCities(cities)
    }

  }

  const filterAreas = (query) => {
    setAreaSearch(query)
    if (query.trim() === "") {
      setFilteredAreas()
    } else {
      const areas = area.data.filter((a) => a.name.toUpperCase().includes(query.toUpperCase()))
      setFilteredAreas(areas)
    }
  }

  return (
    <div className="flex border rounded-xl space-x-2">
      {/*provinces*/}
      <div className="w-48 overflow-y-auto">
        {province.loading ?
          <div>
            {[1, 2, 3, 4, 5, 6].map((n) =>
              <LocationItemLoader key={`province-${n}`} />
            )}
          </div> :
          province.data.map((p, index) => <LocationItem
            key={`province-${p.id}`}
            label={p.name} selected={currentProvince?.id === p.id}
            onSelected={() => {
              dispatch(fetchCitiesByProvince({ provinceId: p.id }))
              dispatch(setCurrentProvince(p))
              filterCities("")
              filterAreas("")

            }}
          />)}
      </div>
      <div className="w-1 h-full bg-secondary-100" />
      {/*cities*/}
      <div className="overflow-y-auto w-52">
        <input placeholder="Search city" className="p-1 m-2 border outline-none" onChange={(e) => {
          filterCities(e.target.value)
        }} value={citySearch} />
        {province.loading || city.loading ?
          <div>{[1, 2, 3, 4, 5, 6].map((n) =>
            <LocationItemLoader key={`cities-${n}`} />
          )}</div> : (filteredCities ?? city.data).map((c, index) => <LocationItem
            key={`city-${c.id}`}
            label={c.name} selected={currentCity?.id === c.id}
            onSelected={() => {
              dispatch(fetchAreasByCity({ cityId: c.id }))
              dispatch(setCurrentCity(c))
              filterAreas("")
            }}
          />)}
      </div>
      <div className="w-1 h-full bg-secondary-100" />
      {/*areas*/}
      <div className="overflow-y-auto w-52">
        <input placeholder="Search Area" className="p-1 m-2 border outline-none" onChange={(e) => {
          filterAreas(e.target.value)
        }} value={areaSearch} />
        {province.loading || city.loading || area.loading ? <div>{[1, 2, 3, 4, 5, 6].map((n) =>
          <LocationItemLoader key={`areas-${n}`} />
        )}</div> : (filteredAreas ?? area.data).map((a, index) =>
          <LocationItem
            key={`area-${a.id}`}
            label={a.name} selected={currentArea?.id === a.id}
            onSelected={() => {
              dispatch(setCurrentArea(a))
            }}
          />)}
      </div>
    </div>
  )
}

const LocationDetailSection = () => {
  const {
    area,
  } = useSelector((state => state.location))

  // for adding cities and areas
  const [isAddingAreas, setIsAddingAreas] = useState(false)
  const [isAddingCities, setIsAddingCities] = useState(false)

  useEffect(() => {
    setIsAddingAreas(false)
  }, [area])

  return <>
    <div className="flex-1 h-full p-2 overflow-y-auto border rounded-xl bg-secondary-100 space-y-4">
      <ProvinceDetail setIsAddingCities={setIsAddingCities} />
      <CityDetail setIsAddingAreas={setIsAddingAreas} isAddingCities={isAddingCities} setIsAddingCities={setIsAddingCities} />
      <AreaDetail isAddingAreas={isAddingAreas} setIsAddingAreas={setIsAddingAreas} />
    </div>
  </>
}
